
export enum TipoCantidadPeriodoDefinidoEnum {
    HORAS = 'HORAS',
    DIAS = 'DIAS',
    PORCENTAJE = 'PORCENTAJE'
}
